import axiosInstance from "../utils/axiosInstance";
import { URLS } from "../utils/baseUrls";

const getUserFields = (teamID) => {
  return axiosInstance.get(`${URLS.fields}/?team_id=${teamID}`);
};

const getOtherFields = () => {
  return axiosInstance.get(`${URLS.fieldList}/`);
};

const getSelectedField = ({ fieldId }) => {
  return axiosInstance.get(`${URLS.fields}/${fieldId}/`);
};

const postFields = (postData, params) => {
  return axiosInstance.post(`${URLS.fields}/`, postData, { params });
};

const updateField = (fieldId, postData) =>
  axiosInstance.patch(`${URLS.fields}/${fieldId}/`, postData);

const deleteField = (fieldId) =>
  axiosInstance.delete(`${URLS.fields}/${fieldId}/`);

const removeUserFromField = (fieldId, email) =>
  axiosInstance.post(`${URLS.fields}/${fieldId}/delete_user/`, { email });

const removeMeFromField = (fieldId) =>
  axiosInstance.post(`${URLS.fields}/${fieldId}/delete_me/`);

const getPruningChoises = ({ fieldId }) => {
  return axiosInstance.get(
    `${URLS.externalRequests}/actions-performed/get_pruning_choices/?field_id=${fieldId}`
  );
};

const getSoilGridData = (fieldId) =>
  axiosInstance.get(`${URLS.externalRequests}/soilgrids/?field_id=${fieldId}`);

const getEquipments = (fieldId) => {
  return axiosInstance.get(`${URLS.fields}/${fieldId}/get_equipments/`);
};

export const fieldsApi = {
  create: postFields,
  delete: deleteField,
  fetchEquipments: getEquipments,
  fetchMy: getUserFields,
  fetchOne: getSelectedField,
  fetchOther: getOtherFields,
  fetchPruningChoises: getPruningChoises,
  removeMe: removeMeFromField,
  removeUser: removeUserFromField,
  soilGrid: getSoilGridData,
  update: updateField,
};
